export const plugins = {
    dataCarrier: {
        availableStatementPeriodicities: [
            'DAILY',
            'WEEKLY',
            'MONTHLY',
            'QUARTERLY',
            'HALFYEARLY',
            'YEARLY',
            'MIDMONTHULTIMO',
            'SBELECTRONIC',
        ],
        availableStatementFormats: ['CAMT53', 'MT940STRUCT', 'MT940UNSTRUCT'],
        isSignableBasedOnSignInfo: false,
        isNewNameInputVisible: false,
        contentTypeHeader: 'application/vnd.presto.latest+json',
    },
};
